import { useContext, createContext } from "react";

export const InvitationsContext = createContext(null);

export function useInvitationsContext() {
  return useContext(InvitationsContext);
}
